
/*
 * DO NOT EDIT THIS FILE. It is automatically generated
 * from its webfont counterpart (same filename without "svg-" prefix).
 * Edit that file instead (material-symbols-outlined.mjs).
 */

import {
  symOutlinedCheckCircle,
  symOutlinedWarning,
  symOutlinedInfo,
  symOutlinedPriorityHigh,
  symOutlinedArrowUpward,
  symOutlinedArrowForward,
  symOutlinedArrowDownward,
  symOutlinedArrowBack,
  symOutlinedArrowDropDown,
  symOutlinedChevronLeft,
  symOutlinedChevronRight,
  symOutlinedGradient,
  symOutlinedTune,
  symOutlinedStyle,
  symOutlinedRefresh,
  symOutlinedKeyboardArrowUp,
  symOutlinedKeyboardArrowDown,
  symOutlinedLens,
  symOutlinedCancel,
  symOutlinedCheck,
  symOutlinedSchedule,
  symOutlinedToday,
  symOutlinedFormatBold,
  symOutlinedFormatItalic,
  symOutlinedStrikethroughS,
  symOutlinedFormatUnderlined,
  symOutlinedFormatListBulleted,
  symOutlinedFormatListNumbered,
  symOutlinedVerticalAlignBottom,
  symOutlinedVerticalAlignTop,
  symOutlinedLink,
  symOutlinedFullscreen,
  symOutlinedFormatQuote,
  symOutlinedFormatAlignLeft,
  symOutlinedFormatAlignCenter,
  symOutlinedFormatAlignRight,
  symOutlinedFormatAlignJustify,
  symOutlinedPrint,
  symOutlinedFormatIndentDecrease,
  symOutlinedFormatIndentIncrease,
  symOutlinedFormatClear,
  symOutlinedTextFormat,
  symOutlinedFormatSize,
  symOutlinedRemove,
  symOutlinedUndo,
  symOutlinedRedo,
  symOutlinedCode,
  symOutlinedFontDownload,
  symOutlinedAdd,
  symOutlinedClose,
  symOutlinedError,
  symOutlinedFirstPage,
  symOutlinedKeyboardArrowLeft,
  symOutlinedKeyboardArrowRight,
  symOutlinedLastPage,
  symOutlinedGrade,
  symOutlinedEdit,
  symOutlinedPlayArrow,
  symOutlinedDone,
  symOutlinedAddBox,
  symOutlinedCloudUpload,
  symOutlinedClearAll,
  symOutlinedDoneAll
} from '@quasar/extras/material-symbols-outlined'

export default {
  name: 'svg-material-symbols-outlined',
  type: {
    positive: symOutlinedCheckCircle,
    negative: symOutlinedWarning,
    info: symOutlinedInfo,
    warning: symOutlinedPriorityHigh
  },
  arrow: {
    up: symOutlinedArrowUpward,
    right: symOutlinedArrowForward,
    down: symOutlinedArrowDownward,
    left: symOutlinedArrowBack,
    dropdown: symOutlinedArrowDropDown
  },
  chevron: {
    left: symOutlinedChevronLeft,
    right: symOutlinedChevronRight
  },
  colorPicker: {
    spectrum: symOutlinedGradient,
    tune: symOutlinedTune,
    palette: symOutlinedStyle
  },
  pullToRefresh: {
    icon: symOutlinedRefresh
  },
  carousel: {
    left: symOutlinedChevronLeft,
    right: symOutlinedChevronRight,
    up: symOutlinedKeyboardArrowUp,
    down: symOutlinedKeyboardArrowDown,
    navigationIcon: symOutlinedLens
  },
  chip: {
    remove: symOutlinedCancel,
    selected: symOutlinedCheck
  },
  datetime: {
    arrowLeft: symOutlinedChevronLeft,
    arrowRight: symOutlinedChevronRight,
    now: symOutlinedSchedule,
    today: symOutlinedToday
  },
  editor: {
    bold: symOutlinedFormatBold,
    italic: symOutlinedFormatItalic,
    strikethrough: symOutlinedStrikethroughS,
    underline: symOutlinedFormatUnderlined,
    unorderedList: symOutlinedFormatListBulleted,
    orderedList: symOutlinedFormatListNumbered,
    subscript: symOutlinedVerticalAlignBottom,
    superscript: symOutlinedVerticalAlignTop,
    hyperlink: symOutlinedLink,
    toggleFullscreen: symOutlinedFullscreen,
    quote: symOutlinedFormatQuote,
    left: symOutlinedFormatAlignLeft,
    center: symOutlinedFormatAlignCenter,
    right: symOutlinedFormatAlignRight,
    justify: symOutlinedFormatAlignJustify,
    print: symOutlinedPrint,
    outdent: symOutlinedFormatIndentDecrease,
    indent: symOutlinedFormatIndentIncrease,
    removeFormat: symOutlinedFormatClear,
    formatting: symOutlinedTextFormat,
    fontSize: symOutlinedFormatSize,
    align: symOutlinedFormatAlignLeft,
    hr: symOutlinedRemove,
    undo: symOutlinedUndo,
    redo: symOutlinedRedo,
    heading: symOutlinedFormatSize,
    code: symOutlinedCode,
    size: symOutlinedFormatSize,
    font: symOutlinedFontDownload,
    viewSource: symOutlinedCode
  },
  expansionItem: {
    icon: symOutlinedKeyboardArrowDown,
    denseIcon: symOutlinedArrowDropDown
  },
  fab: {
    icon: symOutlinedAdd,
    activeIcon: symOutlinedClose
  },
  field: {
    clear: symOutlinedCancel,
    error: symOutlinedError
  },
  pagination: {
    first: symOutlinedFirstPage,
    prev: symOutlinedKeyboardArrowLeft,
    next: symOutlinedKeyboardArrowRight,
    last: symOutlinedLastPage
  },
  rating: {
    icon: symOutlinedGrade
  },
  stepper: {
    done: symOutlinedCheck,
    active: symOutlinedEdit,
    error: symOutlinedWarning
  },
  tabs: {
    left: symOutlinedChevronLeft,
    right: symOutlinedChevronRight,
    up: symOutlinedKeyboardArrowUp,
    down: symOutlinedKeyboardArrowDown
  },
  table: {
    arrowUp: symOutlinedArrowUpward,
    warning: symOutlinedWarning,
    firstPage: symOutlinedFirstPage,
    prevPage: symOutlinedChevronLeft,
    nextPage: symOutlinedChevronRight,
    lastPage: symOutlinedLastPage
  },
  tree: {
    icon: symOutlinedPlayArrow
  },
  uploader: {
    done: symOutlinedDone,
    clear: symOutlinedClose,
    add: symOutlinedAddBox,
    upload: symOutlinedCloudUpload,
    removeQueue: symOutlinedClearAll,
    removeUploaded: symOutlinedDoneAll
  }
}
